import React from 'react';
import PropTypes from 'prop-types';

class SearchForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            input: props.defaultQuery || '',
        };
    }

    handleChange = (event) => {
        const value = event.target.value;
        this.setState({input: value});
        this.props.processQuery(value);
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.processQuery(this.state.input);
    };

    render = () => (
        <form onSubmit={this.handleSubmit} className='search-form'>
            <input
                type='text'
                name='search'
                autoComplete='off'
                value={this.state.input}
                onChange={this.handleChange}
                placeholder='Zoeken'
                className='search-form__input'
            />
            <button type='submit' className='btn btn--xs btn--outline'>
                <svg width='30px' height='30px' viewBox='0 0 30 30' stroke='#231F20'>
                    <g fill='none'>
                        <circle strokeWidth='3' cx='12.5' cy='12.5' r='7.5' />
                        <path d='M18,18 L25,25' strokeWidth='3' />
                    </g>
                </svg>
            </button>
        </form>
    );
}

SearchForm.propTypes = {
    defaultQuery: PropTypes.string.isRequired,
    processQuery: PropTypes.func.isRequired,
};

export default SearchForm;
